export default __webpack_public_path__ + "16eb04ed522c3ecb97076c568d39790a.svg";